<template>
<div class="color justify-center content-center">
    <a href='createvoucher' id="web_btn"><i class="temp fas fa-align-justify cntr content-center  my-14">Create Voucher Template</i></a>
    <br>
    <a href='createledgertemplate' id="icon"><i class="fas fa-align-justify  cntr content-center my-14">create Ledger Template</i></a>
    <br> 
    <a href='createstockitemtemplate' id="icon"><i class="fas fa-align-justify  cntr content-center  my-14">Create Stock Item Template</i></a>
    <a href='edittemplate' id="icon"><i class="fas fa-align-justify ">Edit Template</i></a>
</div>
</template>
<script>
export default {

     data:function(){

     },
     methods:{
        //  template(){
        //      axios.get('')
        //  }
     }
}
</script>
<style scoped>

#icon{
    margin-left:15px;
    cursor:pointer;
}
.color{
    background-color: rgb(156, 203, 169);
    height:100vh;
    text-align: center;
}
.cntr{
    text-decoration: none;
    color: black;
  
}
.temp{
    margin-top: 200px;
}
</style>